import React from 'react'
import { ISectionProps } from './types'
import { Column, Container } from '@/components/base/gridview'
import { functions } from '@wap-client/core'
import Anchor from '@/components/base/anchor'

const Section: React.FC<ISectionProps> = ({
  title,
  subTitle,
  link,
  isColumn = false,
  isNotTitleGap = false,
  isBackdrop = false,
  buttonBgColor = '#9dc118',
  subTitleColor = '#9dc118',
  titleColor = '#fff',
  buttonTextColor = '#fff',
  headerContainerSize = 'fluid',
  childrenContainerSize = 'fluid',
  childrenMarginTop = 48,
  marginTop = 24,
  marginBottom = 12,
  children,
  description,
}) => {
  return (
    <div
      className={functions.classnames(
        'custom-section',
        isBackdrop && 'gradient-backdrop',
      )}
      style={{ marginTop: `${marginTop}px`, marginBottom: `${marginBottom}px` }}
    >
      <Container
        size={headerContainerSize}
        className={functions.classnames(
          'custom-section-header',
          isColumn && 'column-header',
        )}
      >
        <div
          className={functions.classnames(
            'custom-section-header-texts',
            isNotTitleGap && 'title-not-gap',
          )}
        >
          {title && (
            <span
              className="custom-section-header-texts-title"
              style={{ color: titleColor }}
            >
              {title}
            </span>
          )}
          {subTitle && (
            <span
              className="custom-section-header-texts-subtitle"
              style={{ color: subTitleColor }}
            >
              {subTitle}
            </span>
          )}
        </div>
        {description && (
          <Column
            sm={{ size: 12 }}
            md={{ size: 12 }}
            lg={{ size: 12 }}
            xl={{ size: 12 }}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        {link?.children && (
          <Anchor
            className="custom-section-header-button"
            style={{
              backgroundColor: buttonBgColor,
              color: buttonTextColor,
              margin: '24px auto 6px auto',
            }}
            {...link}
          >
            {link.children}
          </Anchor>
        )}
      </Container>
      <Container
        size={childrenContainerSize}
        style={{ marginTop: `${childrenMarginTop}px` }}
        className={
          childrenContainerSize === 'fluid' ? 'custom-section-full' : ''
        }
      >
        {children}
      </Container>
    </div>
  )
}

export default Section
